import {clamp} from '@benchling/js-utils';

import {Thunk} from 'redux-stores/Store';

export enum MenuActionType {
  MENU_SELECTABLE_INDICES_UPDATED = 'MENU_SELECTABLE_INDICES_UPDATED',
  MENU_CHANGE_HOVER_INDEX = 'MENU_CHANGE_HOVER_INDEX',
  /** for testing only */
  TEST_ONLY_SET_OPEN_ALL_SUBMENUS = 'TEST_ONLY_SET_OPEN_ALL_SUBMENUS',
}

export interface MenuOptionDatasUpdatedAction {
  type: MenuActionType.MENU_SELECTABLE_INDICES_UPDATED;
  cid: string;
  hoverIndex: number;
  selectableIndices: Array<number>;
}

function menuSelectableIndicesUpdated(
  cid: string,
  hoverIndex: number,
  selectableIndices: Array<number>
): MenuOptionDatasUpdatedAction {
  return {
    type: MenuActionType.MENU_SELECTABLE_INDICES_UPDATED,
    cid,
    hoverIndex,
    selectableIndices,
  };
}

export function updateMenuSelectableOptions(cid: string, selectableIndices: Array<number>): Thunk<void> {
  return (dispatch, getState) => {
    dispatch(menuSelectableIndicesUpdated(cid, 0, selectableIndices));
  };
}

export interface MenuChangeHoverIndexAction {
  type: MenuActionType.MENU_CHANGE_HOVER_INDEX;
  cid: string;
  hoverIndex: number;
}

export function menuHoverIndexChanged(cid: string, clampedHoverIndex: number): MenuChangeHoverIndexAction {
  return {
    type: MenuActionType.MENU_CHANGE_HOVER_INDEX,
    cid,
    hoverIndex: clampedHoverIndex,
  };
}

function _clampHoverIndex(hoverIndex: number, selectableIndices: Array<number>): number {
  return clamp(0, selectableIndices.length - 1, hoverIndex);
}

export function changeHoverIndex(cid: string, newHoverIndex: number): Thunk<number> {
  return (dispatch, getState) => {
    const selectableIndices = getState().ui.menus.menusByCid[cid].selectableIndices;
    const clampedHoverIndex = _clampHoverIndex(newHoverIndex, selectableIndices);
    dispatch(menuHoverIndexChanged(cid, clampedHoverIndex));
    return clampedHoverIndex;
  };
}

export function hoverOption(cid: string, selectableIndex: number): Thunk<void> {
  return (dispatch, getState) => {
    const hoverIndex = getState().ui.menus.menusByCid[cid].selectableIndices.indexOf(selectableIndex);
    dispatch(menuHoverIndexChanged(cid, hoverIndex));
  };
}

export interface TestOnlySetOpenAllSubmenusAction {
  type: MenuActionType.TEST_ONLY_SET_OPEN_ALL_SUBMENUS;
  cid: string;
  openAllSubmenus: boolean;
}

export function testOnlySetOpenAllSubmenusFlag(
  cid: string,
  openAllSubmenus: boolean
): TestOnlySetOpenAllSubmenusAction {
  return {
    type: MenuActionType.TEST_ONLY_SET_OPEN_ALL_SUBMENUS,
    cid,
    openAllSubmenus,
  };
}

export function testOnlyOpenAllSubmenus(cid: string, openAllSubmenus: boolean): Thunk<void> {
  return (dispatch, getState) => {
    dispatch(testOnlySetOpenAllSubmenusFlag(cid, openAllSubmenus));
  };
}

export type MenuAction =
  | MenuChangeHoverIndexAction
  | MenuOptionDatasUpdatedAction
  | TestOnlySetOpenAllSubmenusAction;
